/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, } from './Address';
import { BountyEscrowStatusFromJSON, BountyEscrowStatusToJSON, } from './BountyEscrowStatus';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { IncidentReportFromJSON, IncidentReportToJSON, } from './IncidentReport';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
import { UserProfileFromJSON, UserProfileToJSON, } from './UserProfile';
/**
 * Check if a given object implements the Bounty interface.
 */
export function instanceOfBounty(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyFromJSON(json) {
    return BountyFromJSONTyped(json, false);
}
export function BountyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (json['deletedAt'] === null ? null : new Date(json['deletedAt'])),
        'rowVersion': !exists(json, 'rowVersion') ? undefined : json['rowVersion'],
        'createdBySubject': !exists(json, 'createdBySubject') ? undefined : json['createdBySubject'],
        'updatedBySubject': !exists(json, 'updatedBySubject') ? undefined : json['updatedBySubject'],
        'userProfileId': !exists(json, 'userProfileId') ? undefined : json['userProfileId'],
        'userProfile': !exists(json, 'userProfile') ? undefined : UserProfileFromJSON(json['userProfile']),
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'windowStartDateTime': !exists(json, 'windowStartDateTime') ? undefined : (new Date(json['windowStartDateTime'])),
        'windowEndDateTime': !exists(json, 'windowEndDateTime') ? undefined : (new Date(json['windowEndDateTime'])),
        'windowTimezone': !exists(json, 'windowTimezone') ? undefined : json['windowTimezone'],
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'requestDescription': !exists(json, 'requestDescription') ? undefined : json['requestDescription'],
        'additionalInformation': !exists(json, 'additionalInformation') ? undefined : json['additionalInformation'],
        'rewardAmountPoints': !exists(json, 'rewardAmountPoints') ? undefined : json['rewardAmountPoints'],
        'moderationStatus': !exists(json, 'moderationStatus') ? undefined : ModerationStatusFromJSON(json['moderationStatus']),
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
        'isClaimed': !exists(json, 'isClaimed') ? undefined : json['isClaimed'],
        'claimedAt': !exists(json, 'claimedAt') ? undefined : (json['claimedAt'] === null ? null : new Date(json['claimedAt'])),
        'isPaidInFull': !exists(json, 'isPaidInFull') ? undefined : json['isPaidInFull'],
        'paidInFullAt': !exists(json, 'paidInFullAt') ? undefined : (json['paidInFullAt'] === null ? null : new Date(json['paidInFullAt'])),
        'escrowStatus': !exists(json, 'escrowStatus') ? undefined : BountyEscrowStatusFromJSON(json['escrowStatus']),
        'escrowedPoints': !exists(json, 'escrowedPoints') ? undefined : json['escrowedPoints'],
        'incidentReports': !exists(json, 'incidentReports') ? undefined : (json['incidentReports'] === null ? null : json['incidentReports'].map(IncidentReportFromJSON)),
        'claimedIncidentReportId': !exists(json, 'claimedIncidentReportId') ? undefined : json['claimedIncidentReportId'],
        'claimedIncidentReport': !exists(json, 'claimedIncidentReport') ? undefined : IncidentReportFromJSON(json['claimedIncidentReport']),
    };
}
export function BountyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'isDeleted': value.isDeleted,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'rowVersion': value.rowVersion,
        'createdBySubject': value.createdBySubject,
        'updatedBySubject': value.updatedBySubject,
        'userProfileId': value.userProfileId,
        'userProfile': UserProfileToJSON(value.userProfile),
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressToJSON(value.address),
        'windowStartDateTime': value.windowStartDateTime === undefined ? undefined : (value.windowStartDateTime.toISOString()),
        'windowEndDateTime': value.windowEndDateTime === undefined ? undefined : (value.windowEndDateTime.toISOString()),
        'windowTimezone': value.windowTimezone,
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'requestDescription': value.requestDescription,
        'additionalInformation': value.additionalInformation,
        'rewardAmountPoints': value.rewardAmountPoints,
        'moderationStatus': ModerationStatusToJSON(value.moderationStatus),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'isClaimed': value.isClaimed,
        'claimedAt': value.claimedAt === undefined ? undefined : (value.claimedAt === null ? null : value.claimedAt.toISOString()),
        'isPaidInFull': value.isPaidInFull,
        'paidInFullAt': value.paidInFullAt === undefined ? undefined : (value.paidInFullAt === null ? null : value.paidInFullAt.toISOString()),
        'escrowStatus': BountyEscrowStatusToJSON(value.escrowStatus),
        'escrowedPoints': value.escrowedPoints,
        'incidentReports': value.incidentReports === undefined ? undefined : (value.incidentReports === null ? null : value.incidentReports.map(IncidentReportToJSON)),
        'claimedIncidentReportId': value.claimedIncidentReportId,
        'claimedIncidentReport': IncidentReportToJSON(value.claimedIncidentReport),
    };
}
